import React from 'react';

const PasswordSVG = () => (
  <svg width={64} height={80}>
    <title>{'8526402D-1E75-4391-A4D2-3913067B23CF'}</title>
    <defs>
      <linearGradient x1="18%" y1="0%" x2="82%" y2="100%" id="prefix__a">
        <stop stopColor="#00FFD3" offset="0%" />
        <stop stopColor="#0CF" offset="100%" />
      </linearGradient>
      <filter
        x="-3.1%"
        y="-2.5%"
        width="106.2%"
        height="105%"
        filterUnits="objectBoundingBox"
        id="prefix__c"
      >
        <feOffset dy={-4} in="SourceAlpha" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2={-1}
          k3={1}
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowInnerInner1"
        />
      </filter>
      <path
        d="M64.624 31.88v-8.368C64.624 10.548 53.958 0 40.847 0 27.737 0 17.07 10.548 17.07 23.512v8.13C11.899 32.644 8 36.947 8 42.089v27.25C8 75.418 12.535 80 18.549 80h42.082C66.898 80 72 75.217 72 69.338v-27.25c-.002-4.95-3.011-8.907-7.376-10.208zM46.666 64.787H33.333v-18.46h13.333v18.46zm9.07-33.362H25.959v-7.91c0-8.119 6.68-14.724 14.888-14.724 8.211 0 14.889 6.605 14.889 14.723v7.91z"
        id="prefix__b"
      />
    </defs>
    <g transform="translate(-8)" fillRule="nonzero" fill="none">
      <use fill="url(#prefix__a)" xlinkHref="#prefix__b" />
      <use fill="#000" filter="url(#prefix__c)" xlinkHref="#prefix__b" />
    </g>
  </svg>
);

export default PasswordSVG;



// WEBPACK FOOTER //
// ./src/components/Icon/PasswordSVG.js